import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VendorMaster } from 'src/app/shared/models/vendor-master';
import { DataService } from 'src/app/shared/services/data-service/data.service';

@Component({
  standalone: false,
  selector: 'vendor-input',
  templateUrl: './vendor-input.component.html',
  styleUrls: ['./vendor-input.component.scss'],
})
export class VendorInputComponent {
  keyword = 'fullName';
  data: VendorMaster[];
  isLoading: boolean;
  @Input() error: string = '';
  @Input() selectedValue: string = '';
  @Output() selectedValueChange = new EventEmitter<string>();

  constructor(private dataService: DataService) {}

  selectEvent(item: VendorMaster) {
    this.selectedValue = item.vendor_Number;
    this.selectedValueChange.emit(this.selectedValue);
  }

  async onChangeSearch(val: string) {
    this.selectedValue = val;
    this.selectedValueChange.emit(this.selectedValue);

    this.isLoading = true;
    this.data = await this.dataService.searchVendor(val.toUpperCase());
    this.isLoading = false;
  }

  onFocused(e: any) {
    // do something when input is focused
  }
}

